var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-layout',{attrs:{"use":"core-layout-default","single-page":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('app-sales-iframe',{attrs:{"src":_vm.src}},[_vm._v("Keine Presentation verfügbar")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }